import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { COOKIE_KEY } from './Api';

const eventMap = {
  'DualCurrency.Lite': 'dual-currency-lite-plugin-download',
  'Email.Reporting.Lite': 'email-reporting-plugin-lite-download',
  'ExpirationDate.Lite': 'expiration-date-lite-plugin-download',
  'EInvoice.Ksa.Lite': 'ksa-einvoice-lite-plugin-download',
  'Logo.Lite': 'logo-plugin-lite-download',
  'Mrp.Lite': 'mrp-lite-plugin-download',
  'NamedOrder': 'named-order-plugin-download',
  'Notes': 'notes-plugin-download',
  'PriceLists.Lite': 'price-lists-plugin-download',
  'Print.Stations.Lite': 'print-stations-plugin-download',
  'StockControl.Lite': 'stock-control-plugin-download',

  'data-migration-tool': 'networking-update-download',
  'Pro.Update': 'networking-update-download',
  'Pro.Setup': 'pro-version-download',
  'Lite.Setup': 'lite-version-download',

  'DualCurrency.Pro': 'dual-currency-pro-plugin-download',
  'Email.Reporting.Pro': 'email-reporting-plugin-pro-download',
  'ExpirationDate.Pro': 'expiration-date-pro-plugin-download',
  'EInvoice.Ksa.Pro': 'ksa-einvoice-pro-plugin-download',
  'Logo.Pro': 'logo-plugin-pro-download',
  'Mrp.Pro': 'mrp-pro-plugin-download',
  'NamedOrder.Networking': 'named-order-networking-plugin-download',
  'Notes.Networking': 'notes-networking-plugin-download',
  'PriceLists.Pro': 'price-lists-pro-plugin-download',
  'Print.Stations.Pro': 'print-stations-networking-plugin-download',
  'StockControl.Pro': 'stock-control-networking-plugin-download',
};

const getEventNameFromHref = (href) => {
  for (const key in eventMap) {
    if (href.includes(key)) return eventMap[key];
  }
  return null;
};

const cookieConstentPresent = () => {
  var cookie = localStorage.getItem(COOKIE_KEY);
  return cookie ? JSON.parse(cookie)?.analytics === true : false;
};

export const loadGA4 = () => {
  // Prevent multiple loads of the same script
  if (window.gtagInitialized) {
    return;
  }

  // Set the session cookie immediatelly so other calls can be ignored
  window.gtagInitialized = true;

  // Generate GA4 script and add it to the document head
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-WH9Q4909XW';
  script.async = true;
  script.onload = () => {
    window.gtag('js', new Date());
    window.gtag('config', 'G-WH9Q4909XW');
  };
  document.head.appendChild(script);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}`;
  document.head.appendChild(inlineScript);
};

const AnalyticsTracker = () => {
  const location = useLocation();
  const lastPathname = useRef('');

  // Check if cookie consent is present and load GoogleAnalytics
  if (cookieConstentPresent()) {
    loadGA4();
  }

  useEffect(() => {
    if (lastPathname.current !== location.pathname) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
          page_title: document.title,
          page_location: window.location.href,
        });
      }
      lastPathname.current = location.pathname;
    }
  }, [location]);

  useEffect(() => {
    const handleClick = (e) => {
      if (!cookieConstentPresent()) return;
      const target = e.target.closest('a, button');
      if (!target) return;

      const href = target.getAttribute('href') || '';
      const mappedEventName = getEventNameFromHref(href);
      const manualEvent = target.getAttribute('data-analytics-event');
      const eventName = manualEvent || mappedEventName;

      if (eventName && typeof window.gtag === 'function') {
        window.gtag('event', eventName, {
          event_category: 'Interaction',
          event_label: href || target.innerText || 'Unknown',
          value: 1,
        });
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return null;
};

export default AnalyticsTracker;
